import { createFileRoute } from '@tanstack/react-router';

import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from '@apps/web/components/ui/card';

const FIXTURES = [
    {
        name: 'WellSky Shift 12345',
        href: '/admin/extension-lab/ehr/wellsky/shifts/12345',
    },
    {
        name: 'WellSky Client 67890',
        href: '/admin/extension-lab/ehr/wellsky/clients/67890',
    },
    {
        name: 'WellSky Caregiver 54321',
        href: '/admin/extension-lab/ehr/wellsky/caregivers/54321',
    },
    {
        name: 'AxisCare Shift 555',
        href: '/admin/extension-lab/ehr/axiscare/shifts/555',
    },
    {
        name: 'HHAExchange Shift 777',
        href: '/admin/extension-lab/ehr/hhaexchange/shifts/777',
    },
];

export const Route = createFileRoute('/_app/admin/extension-lab/')({
    component: ExtensionLabIndexPage,
});

function ExtensionLabIndexPage() {
    return (
        <div className="space-y-6 p-6">
            <div>
                <h1 className="text-2xl font-semibold">Extension Lab</h1>
                <p className="text-muted-foreground mt-1 text-sm">
                    Use these fake EHR pages to validate extension context
                    detection and sidebar object suggestions end-to-end.
                </p>
            </div>
            <Card>
                <CardHeader>
                    <CardTitle>Fixture Pages</CardTitle>
                </CardHeader>
                <CardContent className="space-y-2">
                    {FIXTURES.map((fixture) => (
                        <a
                            key={fixture.href}
                            href={fixture.href}
                            className="hover:bg-muted block rounded-md border px-3 py-2 text-sm transition-colors"
                        >
                            {fixture.name}
                        </a>
                    ))}
                </CardContent>
            </Card>
            <Card>
                <CardHeader>
                    <CardTitle>How to test</CardTitle>
                </CardHeader>
                <CardContent className="text-muted-foreground space-y-2 text-sm">
                    <p>1. Open one of the fixture pages above.</p>
                    <p>2. Open the Chrome extension side panel.</p>
                    <p>
                        3. Verify the side panel detects provider/object context
                        and renders the action button.
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}
